<template>
  <td :class="alignClass">{{ processedData }}</td>
</template>

<script>
  
  export default {
    
    props: {
      column: "",
      data: "",
      headers: {
        type: Array,
        default() {
          return []
        }
      }
    },

    computed: {

      header () {
        
        let header = null
        
        if (this.headers.length) {
          let header = this.headers.filter(item => this.column === item.value)
          if (header.length && header[0]) {
            return header[0]
          }
        }

        return header
      },
      
      alignClass() {
        
        let _class = ""

        if (this.header && this.header.align) {
          switch(this.header.align){
            case 'center':
              _class = 'text-xs-center'
            break
            case 'right':
              _class = 'text-xs-right'
            break
          }
        }

        return _class

      },

      processedData() {
                
        if ((this.data || this.data == 0)) {
          if (this.header && this.header.customFilter) {
            return this.$options.filters[this.header.customFilter](this.data)
          }
        }
        else if(this.header && this.header.default){
          return this.header.default
        }

        return this.data
      }

    },

  }

</script>
